<template>
    <div class="navbar-collapse-mobile mt-1 mb-auto"> 
         <!-- Navbar brand -->
  <a class=" nav-link" :href="'/'">
  <img class="logo-mobile img-fluid w-75" :src="'/images/FixTrACk.png'" >
  </a>
    <ul class="navbar-nav-mob">
    <li class="nav-item fw-500 f-18 ">
      <a class=" nav-link" :href="''">Home <span class="sr-only">(current)</span></a>
    </li>
    <li class="nav-item f-18 fw-500 has--mobile__submenu ">
      <div class="has--submenu_itenms d-flex justify-content-between align-items-center mobile_submenu_icon" @click="toogleFeatures">
        <a class=" nav-link " :href="'#'"> Features</a>
        <i class="fas fa-chevron-down ml-2 f-11 mobile_submenu_icon"></i>
      </div>
      <ul class="dropdown-menu mobile_maga--menu border-0" :class="{'active': isFeaturesActive}">
        <p><strong>Attract Customers</strong></p>
          <li><a class="dropdown-item" :href="'/features/marketing'">Marketing</a></li>
          <li><a class="dropdown-item" :href="'/features/online-appointments'">Client Appointment Scheduling</a></li>
          <!-- <li><a class="dropdown-item" :href="'/coming_soon'">Loyalty Program</a></li> -->
          <li><a class="dropdown-item" :href="'/features/store-credits'">Store Credits</a></li>
          <li><a href="/coming_soon" class="dropdown-item">Device Management</a></li>
          <li><a href="https://ifixyour.com/" class="dropdown-item">Ask an Expert</a></li>
          <li><a href="/coming_soon" class="dropdown-item">Feedback Collection</a></li>
          <p class="mt-2"><strong>Sell More</strong></p>
          <li><a class="dropdown-item" :href="'/features/point-of-sale'">Repair Shop POS</a></li>
          <li><a class="dropdown-item" :href="'/features/payments'">Payments</a></li>
          <li><a class="dropdown-item" :href="'/features/self-check-in'">Self Check-In</a></li>
          <li><a class="dropdown-item" :href="'/features/customer-facing'">Customer Facing Display</a></li>
          <li><a href="/coming_soon" class="dropdown-item">Enterprise & B2B Support</a></li>
           <li><a href="/coming_soon" class="dropdown-item">Task Management</a></li>
          <li><a href="/coming_soon" class="dropdown-item">Support Ticket Management</a></li>
          <li><a href="/coming_soon" class="dropdown-item">Mail-in Client Support</a></li>
          <!-- <li><a class="dropdown-item" :href="'/coming_soon'">Phone System Coming Soon</a></li> -->
          <p class="mt-2"><strong>Increase Efficiency</strong></p>
          <li><a class="dropdown-item" :href="'/features/repair-ticket'">Repair Ticket Management</a></li>
          <li><a class="dropdown-item" :href="'/features/employee-management'">Employee Management</a></li>
          <li><a class="dropdown-item" :href="'/features/inventory'">Inventory</a></li>
          <li><a class="dropdown-item" :href="'/features/billing-invoice'">Billing and Invoices</a></li>
          <li><a class="dropdown-item" :href="'/features/reporting'">Reporting</a></li>
          <li><a href="coming_soon" class="dropdown-item">iOS/Android App for Clients</a></li>
          <li><a href="coming_soon" class="dropdown-item">iOS/Android App for Management</a></li>
          <li><a href="/coming_soon" class="dropdown-item" data-id="point-of-sale">Employee & Technician Schedule Management</a></li>
        </ul>
    </li>
    <!-- <li class="nav-item f-18 fw-500">
      <a class=" nav-link " :href="'/about_us'">About</a>
    </li> -->
    <li class="nav-item f-18 fw-500 pricing-list" :class="{'pricing-height': isFeaturesActive}">
      <a class=" nav-link " :href="'/pricing'">Pricing</a>
    </li>
    <li class="nav-item f-18 fw-500">
        <a class=" nav-link " target="_blank" :href="'https://ifixyour.com/'">Ask an Expert </a>
      </li>
    <li class="nav-item f-18 fw-500">
      <a class=" nav-link " :href="'/demo'">Request a Demo</a>
    </li>
     <li class="nav-item f-18 fw-500">
      <a class=" nav-link " :href="'/book-repair'">Book a Repair</a>
    </li>
    <div class="d-flex gap-5">
    <li class="nav-item btn-padding">
      <base-button :classButton="'bg-white btn-login-nav text-black font-weight-bold f-16'" :title="'login'" :buttonUrl="'https://app.fixtrack.com/login-to-app'"></base-button>
    </li>
    <li class="nav-item btn-padding">
      <base-button :classButton="'btn-bg-golden btn-free-trail text-black font-weight-bold f-16'" :title="'Signup'" :buttonUrl="'https://app.fixtrack.com/register-tenant'"></base-button>
    </li>
    </div>
  </ul>
</div>
</template>
<script>
import BaseButton from '../components/UI/BaseButton.vue'

export default {
  data(){
    return{
      isFeaturesActive: false,
    }
  },
  components: {
    BaseButton,
  },
  mounted() {
    var mobileSubmenuIcon = document.querySelector('.mobile_submenu_icon');

     mobileSubmenuIcon.addEventListener('click', function() {
          var pricing = document.querySelector('.mobile__nav');
      
        pricing.classList.toggle('menu-height');
    });
  },
  methods: {
    toogleFeatures(){
       this.isFeaturesActive=!this.isFeaturesActive;
    }
  },
};
</script>